<!--
/**
 *@author hhy
 *@date 2023年2月10日
 财务管理 对账管理 占位费收支账单
*/
-->
<template>
  <custom-list
    search-btn-text="查询"
    reset-btn-text="恢复默认"
    table-title="占位费收支账单"
    warm-tips="温馨提示：请选择商户名称查看数据。"
    search-param-validate-err-msg="请选择商户名称进行查询"
    :show-header="true"
    :request-call="false"
    :search-data="searchData"
    :search-params="searchParam"
    :table-columns="tableColumns"
    :table-operate-buttons="tableOperateButtons"
    :search-params-validate-keys="['operatorId']"
    :request-method="reconciliationApi.placeholderBillList"
    :header-buttons="headerButtons.filter(item => item.enabled())"
    @query-form="handleSearchConfirm"
    @clear-form="handleSearchClean" />
</template>

<script>
  import { directPage, reconciliationApi } from '@/service/apis';
  import { code, getLastTime, getLastYear, offlineExport } from '@/utils';

  import CustomList from '@/components/biz/CustomList.vue';

  export default {
    name: 'InterconnectedBillingStatementsList',
    components: { CustomList },
    data() {
      return {
        id: '',
        isEdit: false,
        reconciliationApi,
        operatorListData: [], // 商户名称
        polymerizationInfo: {},
        tableData: [],
        tableOperateButtons: [],
        tableColumns: [
          { label: '账单时间', prop: 'summaryDate', minWidth: '100px' },
          { label: '商户名称', prop: 'operatorName', minWidth: '100px' },
          {
            label: '占位费收入',
            prop: 'totalOrderAmt',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span
                    class="link"
                    onClick={() => {
                      this.gotoDetail(row, 'income');
                    }}>
                    {row.totalOrderAmt}
                  </span>
                );
              },
            },
          },
          {
            label: '占位费退款',
            prop: 'totalOrderRefund',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span
                    class="link"
                    onClick={() => {
                      this.gotoDetail(row, 'refund');
                    }}>
                    {row.totalOrderRefund}
                  </span>
                );
              },
            },
          },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParam: {
          date: [],
          dateType: 1,
          billStartTime: '',
          billEndTime: '',
        },
      };
    },
    computed: {
      headerButtons() {
        return [
          {
            enabled: () => code('finance:reconci:place:export'),
            label: '导出',
            handle: (data, ctx) => {
              console.log('-> data', data);
              console.log('-> ctx', ctx);
              offlineExport(
                {
                  downloadType: 'parking_order_bill',
                  jsonNode: {
                    // downloadKey: 'message',
                    ...ctx.searchParam,
                  },
                },
                ctx.pageInfo.total
              );
            },
          },
        ];
      },
      searchData() {
        return [
          {
            key: 'date',
            isDateType: true,
            label: '账单日期',
            comName: 'YkcDatePicker',
            change: this.handleChange,
          },
          {
            key: 'operatorId',
            label: '商户名称',
            placeholder: '请输入商户名称',
            comName: 'YkcDropdown',
            data: this.operatorListData,
            remote: true,
          },
        ];
      },
    },
    created() {
      const startDate = getLastTime('yyyy-MM-dd', 7);
      const endDate = getLastTime('yyyy-MM-dd', 1);

      this.searchParam.date = [startDate, endDate];
      this.searchParam.billStartTime = startDate;
      this.searchParam.billEndTime = endDate;
      this.queryOperatorList();
    },
    methods: {
      gotoDetail(row, type = 'income') {
        this.$router.push({
          path: '/financialManagement/occupancyFeeReceiptsPayments/occupancyFeeReceiptsPaymentsDetail',
          query: {
            operatorId: row.operatorId,
            summaryDate: row.summaryDate,
            dateType: this.searchParam.dateType,
            payType: type === 'income' ? '1' : '2',
          },
        });
      },
      queryOperatorList() {
        directPage.userOperatorList({ keyword: '' }).then(res => {
          this.operatorListData = (res || []).map(({ operatorId, name }) => ({
            name,
            id: String(operatorId),
          }));
        });
      },
      /**
       * 切换日月
       */
      handleChange(obj) {
        const { select, event } = obj;

        // 下拉选择操作默认日期
        if (event === 'select' && select === 'monthrange') {
          // 切换到月
          const monthStr = getLastYear(3, 1);
          const startDateStr = monthStr.startTime;
          const endDateStr = monthStr.endTime;

          this.searchParam.date = [startDateStr, endDateStr];
          this.searchParam.billStartTime = startDateStr;
          this.searchParam.billEndTime = endDateStr;
          this.searchParam.dateType = 2;
        } else if (event === 'select' && select === 'daterange') {
          // 切换到日
          const startDateStr = getLastTime('yyyy-MM-dd', 7);
          const endDateStr = getLastTime('yyyy-MM-dd', 1);

          this.searchParam.date = [startDateStr, endDateStr];
          this.searchParam.billStartTime = startDateStr;
          this.searchParam.billEndTime = endDateStr;
          this.searchParam.dateType = 1;
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(searchData) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParam, searchData);

        // 时间选择
        if (searchData.date && Array.isArray(searchData.date) && searchData.date.length > 0) {
          [this.searchParam.billStartTime, this.searchParam.billEndTime] = searchData.date;
        }
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParam, form, { dateType: 1 });

        // 切换成日，默认状态
        const startDate = getLastTime('yyyy-MM-dd', 7);
        const endDate = getLastTime('yyyy-MM-dd', 1);

        this.searchParam.date = [startDate, endDate];
        this.searchParam.billStartTime = startDate;
        this.searchParam.billEndTime = endDate;
        this.searchParam.dateType = 1;
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
      },
    },
  };
</script>

<style scoped lang="scss">
  .link {
    color: blue;
    cursor: pointer;
  }
  .card-info-area {
    box-sizing: border-box;
    .card-info {
      display: flex;
      box-sizing: border-box;
      flex-wrap: nowrap;
      flex-grow: 1;
      width: 892px;
      height: 125px;
      //line-height: 125px;
      background: #ffffff;
      box-shadow: 1px 1px 4px 1px rgba(94, 94, 94, 0.09);
      align-content: center;
      align-items: center;
    }
    .common-icon {
      display: inline-flex;
      box-sizing: border-box;
      width: 70px;
      height: 70px;
      margin-left: 30px;
      background: rgba(77, 140, 253, 0.1);
      border-radius: 14px;
      line-height: 70px;
      align-content: center;
      text-align: center;
      align-items: center;
      justify-content: center;
      .big-icon {
        width: 32px;
        height: 32px;
        display: inline-block;
        background-image: url('~@/assets/images/financial/customDriver/purse@2x.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .common-text {
      display: inline-flex;
      flex-direction: column;
      margin-left: 30px;
      .account-name {
        //width: 108px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 25px;
      }
      .purse-text {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        //display: inline-flex;
        //align-items: center;
      }
      .purse-balance {
        //width: 261px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        .purse-unit {
          width: 19px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
      }
    }
    .common-label-key {
      display: inline-block;
      width: 60px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9b9b9b;
      line-height: 17px;
    }
    .common-label-val {
      display: inline-block;
      //width: 24px;
      //height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
      margin-left: 8px;
    }
    .white-stone {
      width: 16px;
      height: 125px;
    }
  }
</style>
